import { render } from "./PageSlider.vue?vue&type=template&id=37726f96&scoped=true"
import script from "./PageSlider.vue?vue&type=script&lang=js"
export * from "./PageSlider.vue?vue&type=script&lang=js"

import "./PageSlider.vue?vue&type=style&index=0&id=37726f96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37726f96"]])

export default __exports__